import { withInstall } from '@mts-fe/utils';
import { PCMode } from '@mts/utils/env';
import _PadPage from './src/PadPage.vue';
import _PageFooter from './src/PageFooter.vue';
import _PageWrapper from './src/PageWrapper.vue';
import _PcPage from './src/PcPage.vue';

export const MPage = withInstall(PCMode ? _PcPage : _PadPage);

export const PageFooter = withInstall(_PageFooter);
export const PageWrapper = withInstall(_PageWrapper);
